import React from "react";

function Forbidden() {
  return (
    <p className="p-4 text-center text-lg text-slate-400 dark:text-slate-600">
      Forbidden
    </p>
  );
}

export default Forbidden;
